export default __webpack_public_path__ + "static/media/3.055d4a00.jpg";